import { render, staticRenderFns } from "./customizationAbout.vue?vue&type=template&id=6bf86276"
import script from "./customizationAbout.vue?vue&type=script&lang=js"
export * from "./customizationAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports